import { Divider as Divider$1 } from '@mui/material';
import { styled, css } from '@mui/material/styles';
import { spacing } from '@mui/system';
import { shouldNotForwardProps, withUtility } from '../../foundation/utils.js';

let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4;
const Divider = styled(Divider$1, {
  shouldForwardProp: shouldNotForwardProps
})(_t || (_t = _`
  ${0};

  ${0}
`), spacing, withUtility(({
  palette
}, {
  hierarchy
}) => {
  switch (true) {
    case hierarchy === 'primary':
      return css(_t2 || (_t2 = _`
          border-color: ${0};
        `), palette('outline'));
    case hierarchy === 'secondary':
      return css(_t3 || (_t3 = _`
          border-color: ${0};
        `), palette('surfaceVariant'));
    default:
      return css(_t4 || (_t4 = _``));
  }
}));

export { Divider };
